import { State, Effect, Actions, dispatch } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import qs from 'qs'

const ProductState = State({
  initial: {
    kind: '',
    list: []
  },
  setProducts (state, payload) {
    return {
      ...state,
      list: payload.list,
      kind: payload.kind
    }
  }
})

// eslint-disable-next-line
const loadProductsEffect = Effect('loadProducts', (key) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({key: key})
  return axios.get(`${apiAddress}product/list-by-category${urlParams}`).then((res) => {
    let payload = {list: res.data, kind: key}
    Actions.setProducts(payload)
    return res.data
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const buyEffect = Effect('buy', (order) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.post(`${apiAddress}order`, qs.stringify(order)).then((res) => {
    return res.data
  }).catch(e => {
    return Promise.reject(e)
  })
})

export default ProductState



// WEBPACK FOOTER //
// ./src/states/product.js